import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { PAGE_STATE } from "../../../../constants/constants";
import ManageFormsService from "../../../../../../services/ManageFormsService";
import { componentKey, setLoadingState, setStateFilingAmount } from "./StateFilingSlice";

export const { getStateFilingAmount } = {
    getStateFilingAmount: (payload) => {
        return {
            type: "STATE_FILING/GET_BULK_STATE_AMOUNT",
            payload
        }
    },
}

function* getStateFilingAmountAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading" }));

        const { selectedRows } = action?.payload;
        const response = yield ManageFormsService.getSingleStateAmount(selectedRows);

        const { Data, Status, Message } = response?.data;
        if (Status) {
            yield put(setStateFilingAmount({
                "OnlySeparateStatefiling": "false",
                "TotalFilingFee": Data?.Amount || "0",
                "FilingFee": "0",
                "USPSFee": "0",
                "TINMatchFee": "0",
                "StateFee": Data?.Amount || "0",
                "TINCount": "0",
                "StateFilingCount": "0",
                "USPSCount": "0",
                "FormCount": "0",
                "EstimatedTax": "0",
            }));
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the amount details", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the amount details", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getStateFilingAmount().type, getStateFilingAmountAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);